import React, { useEffect, useState } from 'react'
import SearchBar from '../SearchBar/SearchBar'

const Filter = ({
    setFilteredItems,
    allData,
    searchKeys
}) => {
    const [searchTerm, setSearchTerm] = useState("")

    useEffect(() => {
        const newFilterItems = allData.filter((item) => {

            const matchSearch = searchKeys?.some((key) => {
                return item[key]?.toLowerCase()?.includes(searchTerm.toLowerCase());
            })
            return matchSearch
        })
        // console.log(newFilterItems)
        setFilteredItems(newFilterItems)
    },[searchTerm, allData, searchKeys, setFilteredItems])


    return (
        <div>
            <SearchBar
                setSearchTerm={setSearchTerm}
                searchTerm={searchTerm}

            />
        </div>
    )
}

export default Filter